import React, { useEffect, useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { API_BASE_URL, authHeaders } from "../../api";

const createProject = (id) => ({
    id,
    title: "",
    description: "",
    github: ""
});

function AdminProjects() {
    const [projects, setProjects] = useState([]);
    const [status, setStatus] = useState("");

    useEffect(() => {
        async function loadProjects() {
            try {
                const response = await fetch(`${API_BASE_URL}/api/projects`, {
                    headers: authHeaders()
                });
                const data = await response.json();
                setProjects(data.projects || []);
            } catch (error) {
                console.error("Fehler beim Abrufen der Projekte:", error);
            }
        }

        loadProjects();
    }, []);

    const updateProject = (index, field, value) => {
        setProjects((current) => current.map((project, projectIndex) => (
            projectIndex === index ? { ...project, [field]: value } : project
        )));
    };

    const addProject = () => {
        const nextId = projects.reduce((max, project) => Math.max(max, Number(project.id) || 0), 0) + 1;
        setProjects((current) => [...current, createProject(nextId)]);
    };

    const removeProject = (index) => {
        setProjects((current) => current.filter((_, projectIndex) => projectIndex !== index));
    };

    const saveProjects = async () => {
        setStatus("Speichert...");

        const payload = {
            projects: projects.map((project, index) => ({
                id: Number(project.id) || index + 1,
                title: project.title,
                description: project.description,
                github: project.github === false || project.github === "false" ? false : project.github
            }))
        };

        try {
            const response = await fetch(`${API_BASE_URL}/api/projects`, {
                method: "PUT",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error("Speichern fehlgeschlagen");
            }

            const data = await response.json();
            setProjects(data.projects);
            setStatus("Gespeichert");
        } catch (error) {
            console.error(error);
            setStatus("Fehler beim Speichern");
        }
    };

    return (
        <div className="action-card">
            <h3>Projekte</h3>
            <div className="action-card-body">
                {projects.map((project, index) => (
                    <div className="cv-edit-item" key={`${project.id}-${index}`}>
                        <div className="form-grid">
                            <label className="field-label" htmlFor={`project-title-${index}`}>Titel</label>
                            <input
                                id={`project-title-${index}`}
                                className="text-input"
                                value={project.title}
                                onChange={(event) => updateProject(index, "title", event.target.value)}
                            />

                            <label className="field-label" htmlFor={`project-github-${index}`}>GitHub ZIP-Key</label>
                            <input
                                id={`project-github-${index}`}
                                className="text-input"
                                value={project.github || ""}
                                onChange={(event) => updateProject(index, "github", event.target.value)}
                                placeholder="user/repo oder leer"
                            />
                        </div>

                        <label className="field-label" htmlFor={`project-description-${index}`}>Beschreibung</label>
                        <textarea
                            id={`project-description-${index}`}
                            className="textarea"
                            value={project.description}
                            onChange={(event) => updateProject(index, "description", event.target.value)}
                            style={{ height: "220px" }}
                        />

                        <button
                            type="button"
                            className="btn btn-outline-danger icon-label-button"
                            onClick={() => removeProject(index)}
                        >
                            <Trash2 size={18} />
                            Entfernen
                        </button>
                    </div>
                ))}

                <div className="admin-actions">
                    <button type="button" className="btn btn-secondary icon-label-button" onClick={addProject}>
                        <Plus size={18} />
                        Projekt hinzufügen
                    </button>
                    <button type="button" className="btn btn-success icon-label-button" onClick={saveProjects}>
                        <Save size={18} />
                        Speichern
                    </button>
                    {status && <span className="save-status">{status}</span>}
                </div>
            </div>
        </div>
    );
}

export default AdminProjects;
